import { render, staticRenderFns } from "./pageShengxuetujing.vue?vue&type=template&id=1193854b&scoped=true"
import script from "./pageShengxuetujing.vue?vue&type=script&lang=js"
export * from "./pageShengxuetujing.vue?vue&type=script&lang=js"
import style0 from "./pageShengxuetujing.vue?vue&type=style&index=0&id=1193854b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193854b",
  null
  
)

export default component.exports